import { useMutation } from 'react-query'
import { useWeb3React } from '@web3-react/core'
import { BigNumberish, ethers } from 'ethers'
import { useAddresses } from '../useAddress'
import { Controller__factory } from '../../typechain'
import { Position } from '../../utils/uni'
import { calculateGasMargin } from '../../utils'
import { useDeadline } from '../useBlockTimestamp'
import { MARGIN_USE } from '../../constants'

type OpenPositionParams = {
  vaultId: number
  position: Position
  lowerSqrtPrice: BigNumberish
  upperSqrtPrice: BigNumberish
  metadata: string
  targetMarginAmount0: BigNumberish
  targetMarginAmount1: BigNumberish
}

export function useOpenPosition() {
  const { account, provider } = useWeb3React<ethers.providers.Web3Provider>()
  const addresses = useAddresses()
  const deadline = useDeadline()

  return useMutation(async (params: OpenPositionParams) => {
    if (!account) throw new Error('Account not set')
    if (!provider) throw new Error('provider not set')
    if (!addresses) throw new Error('addresses not set')

    const contract = Controller__factory.connect(
      addresses.Controller,
      provider.getSigner()
    )

    const args = [
      params.vaultId,
      params.position,
      {
        isLiquidationCall: false,
        swapAnyway: true,
        quoterMode: false,
        isQuoteZero: false,
        marginMode0: MARGIN_USE,
        marginMode1: MARGIN_USE,
        deltaMarginAmount0: 0,
        deltaMarginAmount1: 0,
        metadata: params.metadata
      },
      {
        lowerSqrtPrice: params.lowerSqrtPrice,
        upperSqrtPrice: params.upperSqrtPrice,
        swapRatio: 0,
        deadline: deadline.isSuccess ? deadline.data : 0
      }
    ] as const

    const gasUsage = await contract.estimateGas.openPosition(...args)

    return await contract.openPosition(...args, {
      gasLimit: calculateGasMargin(gasUsage)
    })
  })
}
